// Auto-generated file - DO NOT EDIT
// Generated on: 2026-10-20T10:11:07.134Z
// Git branch: dev
// Git commit: 0194721

export const VERSION = "dev";
export const BUILD_TIME = "2026-10-20T10:11:07.134Z";
export const GIT_BRANCH = "dev";
export const GIT_COMMIT = "0194721";
export const BUILD_DATE = "Oct 20, 2026";
export const BUILD_TIME_FORMATTED = "6:11 AM EDT";
export const BUILD_TIMESTAMP = 1792491067150;

// Combined version string for display
export const VERSION_INFO = `${GIT_BRANCH} - ${BUILD_DATE} ${BUILD_TIME_FORMATTED}`;
export const FULL_VERSION_INFO = `${GIT_BRANCH} - ${BUILD_DATE} ${BUILD_TIME_FORMATTED} - ${GIT_COMMIT}`;
